<template>
  <div class="image_bg">
    <div class="form">
        <div class="brand_box_b">
        <div class="brand_name">有朋相册</div>
        <div class="brand_dscp">您的专属家庭相册、朋友相册、团队相册<br>一个有温度、有归属感的共享相册</div>
        </div>
        <div class="login_box_b">
        <input class="field" label="手机" placeholder="手机" type="tel" v-model.trim="mobilePhone" />
        <input class="field" placeholder="密码 (默认为注册时的短信验证码)" type="password" v-model.trim="password" />
        <div class="btn_large" @click="login">登录</div>
        <div class="btn_box">
            <div class="btn_left" @click="goToResetPassword">忘记密码</div>
            <div class="btn_right">没有账号？<span @click="goToSignup">免费注册</span></div>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
export default {
  name: 'LoginB',
  data: function () {
    return {
      mobilePhone: '',
      password: ''
    }
  },
  methods: {
    async login () {
      try {
        if (!this.mobilePhone) {
          return Toast({
            message: '请填写手机号码'
          })
        }

        if (!this.password) {
          return Toast({
            message: '请填写密码'
          })
        }
        
        Indicator.open()

        const loginRes = await this.$faApi.login({
          mobilePhone: this.mobilePhone,
          password: this.password
        })

        if (loginRes.code === 'USER_NOT_EXIST') {
          Indicator.close()
          return Toast({ message: '用户不存在' })
        }
        if (loginRes.code === 'INVALID_PASSWORD') {
          Indicator.close()
          return Toast({ message: '密码错误' })
        }
        
        // 登录完成之后保存accessToken
        localStorage.setItem(this.$faStorage.keys.accessToken, loginRes.accessToken)

        // 加入群
        const inviteCode = localStorage.getItem(this.$faStorage.keys.inviteCode)
        const groupId = localStorage.getItem(this.$faStorage.keys.inviteGroupId)
        if (inviteCode && groupId) {
          const joinGroupRes = await this.$faApi.joinGroupWithInviteCode(inviteCode, groupId)
          if (joinGroupRes.code === 'INVALID_INVITE_CODE') {
            Indicator.close()
            return Toast({ message: '无效邀请码' })
          }
          localStorage.removeItem(this.$faStorage.keys.inviteCode)
          localStorage.removeItem(this.$faStorage.keys.inviteGroupId)
          Indicator.close()
          return this.$router.push({ path: `/group/${groupId}` })
        }

        const loginRedirectUrl = localStorage.getItem(this.$faStorage.keys.loginRedirectUrl)

        Indicator.close()
        if (loginRedirectUrl) {
          localStorage.removeItem(this.$faStorage.keys.loginRedirectUrl)
          return this.$router.push({ path: loginRedirectUrl })
        } else {
          return this.$router.push({ path: `/user/${loginRes.userId}/joined_groups` })
        }
      } catch (err) {
        Indicator.close()
        this.$faLogger.error('LoginB.vue:getSmsCode', err)
      }
    },
    goToSignup() {
      this.$router.push({ path: '/signup_b' })
    },
    goToResetPassword() {
      this.$router.push({ path: '/reset_password' })
    }
  }
}
</script>

<style scoped lang="scss">
  .form {
    margin: 0 auto;
    padding: 16px;
    max-width: 320px;
  }
  .btn_box {
    position: relative;
    width: auto;
    height: 32px;
  }
  .btn_left {
    position: relative;
    float: left;
    width: auto;
    padding: 0 8px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    font-weight: normal;
    color: darkgray;
    cursor: pointer;
  }
  .btn_right {
    position: relative;
    float: right;
    width: auto;
    padding: 0 8px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    font-weight: normal;
    color: darkgray;
    span {
      font-weight: bold;
      color: red;
      cursor: pointer;
    }
  }
.field {
    margin: 8px 0 0 0;
    padding: 0 8px;
    width: 100%;
    height: 40px;
    border-width: 0 0 1px 0;
    border-radius: 0;
    border-bottom: 1px solid white;
    background-color: #ffff;
    text-align: left;
    font-size: 16px;
    font-weight: 300;
  }
</style>
  